import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { LegacyAnalyticsInterface } from '@nerdwallet/calculator-onboarding-modal';
import { InputPercent } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  inputOnChange,
  INPUT_TRACKING_TYPES,
  BedrockInterface,
} from '../../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const PropertyTaxRateInput: React.FC<RentVsBuyInput> = ({
  placeholder,
  value,
  errorMessage,
  analytics,
  dispatch,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
}) => {
  const decimalValue = value;
  const percentageValue = !_.isNil(decimalValue)
    ? num.formatPercent(decimalValue)
    : '';
  const percentagePlaceholder = !_.isNil(placeholder)
    ? num.formatPercent(placeholder)
    : '';
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy: LegacyAnalyticsInterface;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_n',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'propertyTaxRate',
      calculator: RENT_VS_BUY,
      inputType: 'percentage',
    });
  };

  return (
    <InputPercent
      label={label}
      value={percentageValue}
      placeholder={percentagePlaceholder}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
      decimalScale={3}
      numberOfDigits={3}
    />
  );
};

const mapStateToProps = (state) => ({
  placeholder: state?.rentvsbuyCalculator?.manualInputs?.propertyTaxRate,
  value: state?.rentvsbuyCalculator?.inputs?.propertyTaxRate,
  errorMessage: state?.validations?.propertyTaxRate?.[0],
});

export default connect(mapStateToProps)(PropertyTaxRateInput);
